import * as yup from 'yup';

export const NursingTaskSuggestionSchema = yup.object({
  id: yup.string().required(),
  suggestedTaskName: yup.string().required(),
});

export const CreateNursingTaskSuggestionSchema = yup.object({
  suggestedTaskName: yup.string().required(),
});

export const UpdateNursingTaskSuggestionSchema = yup.object({
  id: yup.string().required(),
  suggestedTaskName: yup.string().required(),
});

export type INursingTaskSuggestion = yup.InferType<typeof NursingTaskSuggestionSchema>;
